import {SteuernummerFormat} from '../model/steuernummer-format';

export class SteuernummerHelper {
    // eslint-disable-next-line complexity
    public static getMaskFormat(finanzamtNummer?: string, steuernummer?: string): SteuernummerFormat {
      if (!finanzamtNummer) {
        finanzamtNummer = '';
      }
      if (/^(11|21|22|23|27).*$/.test(finanzamtNummer)) { // NOSONAR
        return {mask: '00/000/00000', prefix: ''};
      } else if (/^5.*$/.test(finanzamtNummer)) {
        return {mask: '000/0000/0000', prefix: ''};
      } else if (/^(10|30|31|32|40|41|9).*$/.test(finanzamtNummer)) {
        return {mask: '000/000/00000', prefix: ''};
      } else if (/^28.*$/.test(finanzamtNummer)) {
        return {mask: '00000/00000', prefix: ''};
      } else if (/^24.*$/.test(finanzamtNummer)) {
        return {mask: '00 000 00000', prefix: ''};
      } else if (/^26.*$/.test(finanzamtNummer)) {

        type SteuernummerFormat = {
          mask: string;
          prefix: string;
        };

        let mask: SteuernummerFormat;

        if (String(steuernummer) !== '' && steuernummer !== null && steuernummer !== undefined) {
          mask = {mask: '000 000 00000', prefix: ''};
        } else {
          mask = {mask: '00 000 00000', prefix: '0'};
        }

        return mask;
      } else {
        return {mask: '00000000000', prefix: ''};
      }
    }
}
